// ─── Selector de operarios del equipo de trabajo al crear la orden ───────────
// La lógica del selector vive en SelectorEquipoAcondicionamiento.js; aquí solo
// se instancia con los IDs del modal de crear.
window.selectorEquipoCrearAcondicionamiento = null;

document.addEventListener('DOMContentLoaded', function () {
    if (typeof window.iniciarSelectorEquipoAcondicionamiento !== 'function') return;
    if (!document.getElementById('formCrearOrdenAcondicionamiento')) return;

    window.selectorEquipoCrearAcondicionamiento = window.iniciarSelectorEquipoAcondicionamiento({
        idFiltro: 'filtroOperarioCrearAcondicionamiento',
        idFiltroArea: 'filtroAreaCrearAcondicionamiento',
        idResultados: 'resultadosOperariosCrearAcondicionamiento',
        idSeleccionados: 'seleccionadosEquipoCrearAcondicionamiento',
        idInputs: 'inputsEquipoCrearAcondicionamiento'
    });
});

document.addEventListener('submit', async function (e) {
    if (e.target.id !== 'formCrearOrdenAcondicionamiento') return;

    e.preventDefault();

    const formulario = e.target;
    const modalPadre = formulario.closest('.modal');
    const btnSubmit = formulario.querySelector('#btnCrearOrdenAcondicionamiento');
    const spinner = formulario.querySelector('#spinner');

    // El formulario está dividido en etiquetas: antes de reportar una validación
    // hay que activar la pestaña donde vive el campo, o el navegador no puede enfocarlo.
    function activarEtiquetaDeCanva(idCanva) {
        const etiqueta = idCanva.replace(/^canva/, '');
        const dataEtiqueta = etiqueta.charAt(0).toLowerCase() + etiqueta.slice(1);
        const boton = document.querySelector('#multiEtiquetaCrearAcondicionamiento button[data-etiqueda="' + dataEtiqueta + '"]');
        if (boton) boton.click();
    }

    if (!formulario.checkValidity()) {
        const campoInvalido = formulario.querySelector(':invalid');
        if (campoInvalido) {
            const canva = campoInvalido.closest('.canvaCrearOrdenAcondicionamiento > div');
            if (canva && canva.classList.contains('oculto')) {
                activarEtiquetaDeCanva(canva.id);
            }
        }
        formulario.reportValidity();
        return;
    }

    if (window.selectorEquipoCrearAcondicionamiento && window.selectorEquipoCrearAcondicionamiento.contar() === 0) {
        activarEtiquetaDeCanva('canvaEquipoCrearAcond');
        if (typeof lanzarAlerta === 'function') {
            lanzarAlerta('Debes seleccionar al menos un operario para el equipo de trabajo.', 'alerta-roja');
        }
        return;
    }

    if (btnSubmit) btnSubmit.disabled = true;
    if (spinner) spinner.style.display = 'inline-block';

    formulario.querySelectorAll('.inputRojo').forEach(function (input) {
        input.classList.remove('inputRojo');
    });

    try {
        const formData = new FormData(formulario);

        const respuesta = await fetch('/api/acondicionamiento/crear', {
            method: 'POST',
            body: formData,
            credentials: 'include'
        });

        let json = null;
        try {
            json = await respuesta.json();
        } catch (errorJson) {
            throw new Error('La respuesta del servidor no es JSON válido.');
        }

        if (!respuesta.ok) {
            console.error('Error HTTP:', respuesta.status, json);
            if (typeof lanzarAlerta === 'function') lanzarAlerta('Error al procesar la solicitud.', 'alerta-roja');
            return;
        }

        if (!json || !json.result) {
            console.error('Respuesta inesperada:', json);
            if (typeof lanzarAlerta === 'function') lanzarAlerta('Respuesta inesperada del servidor.', 'alerta-roja');
            return;
        }

        const resultado = json.result;

        if (resultado.hayErrores) {
            if (Array.isArray(resultado.errores)) {
                resultado.errores.forEach(function (error) {
                    if (typeof lanzarAlerta === 'function') {
                        lanzarAlerta(error.mensaje || 'Error de validación.', error.clase || 'alerta-roja');
                    }
                    if (error.campo) {
                        const campo = formulario.querySelector('[name="' + error.campo + '"]');
                        if (campo) campo.classList.add('inputRojo');
                    }
                });
            }
            return;
        }

        formulario.reset();

        if (window.selectorEquipoCrearAcondicionamiento) {
            window.selectorEquipoCrearAcondicionamiento.limpiar();
        }

        const btnPrimeraEtiqueta = document.querySelector('#multiEtiquetaCrearAcondicionamiento button');
        if (btnPrimeraEtiqueta) btnPrimeraEtiqueta.click();

        if (modalPadre) {
            modalPadre.classList.remove('modal--show');
        }

        const params = new URLSearchParams(window.location.search);
        if (typeof window.actualizarTablaAcondicionamientoPeriodo === 'function') {
            window.actualizarTablaAcondicionamientoPeriodo(params.get('mes'), params.get('año'));
        }

        if (typeof lanzarAlerta === 'function') {
            lanzarAlerta('Orden de trabajo creada con éxito.', 'alerta-verde');
        }

    } catch (error) {
        console.error('Error:', error);
        if (typeof lanzarAlerta === 'function') {
            lanzarAlerta('Error crítico al procesar la solicitud.', 'alerta-roja');
        } else {
            alert('Error crítico al procesar la solicitud.');
        }
    } finally {
        if (btnSubmit) btnSubmit.disabled = false;
        if (spinner) spinner.style.display = 'none';
    }
});
